import { SVGProps } from 'react';

export const IconImage = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 48 38'>
      <g stroke='currentColor' strokeWidth='2' fill='none' fillRule='evenodd'>
        <path d='M7 37h34a6 6 0 006-6V7a6 6 0 00-6-6H7a6 6 0 00-6 6v24a6 6 0 006 6z' />
        <path d='M8 37l11.836-21.002 7.475 13.408L32 23l8 14m1-24.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z' />
      </g>
    </svg>
  );
};
